import { Box, Button, FormControl, Grid, Input, InputLabel, makeStyles, MenuItem, OutlinedInput, Select, TextField } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { Autocomplete } from "@material-ui/lab";

const useStyle = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        borderTop: '1px grey solid',
        borderBottom: '1px grey solid'
    },
    leftSection: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        paddingRight: theme.spacing(2)
    },
    rightSection: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(3),
        borderLeft: '1px grey solid',
        backgroundColor: theme.palette.grey[800],
        color: theme.palette.grey[500],
    }
}))

function SearchActionsSection(props) {
    const classes = useStyle();
    const {t} = useTranslation('deliveryAreaManagement');
    const { warehouses, partners, selectListGroup, airports, isSelected, handleActive } = props;
    const [searchKeys, setSearchKeys] = useState([[], null, null, null]);
    const [selectedWarehouses, setSelectedWarehouses] = useState([]);
    const handleSearchKeys = (value, index) => {
        let arr = _.cloneDeep(searchKeys);
        arr[index] = value;
        setSearchKeys(arr);
    }

    useEffect(() => {
        setSearchKeys([null, null, null, null]);
    }, [props.type])

    return (
        <Box className={classes.root}>
            <Grid
                container 
                alignItems="center"
                justify="center"
            >
                <Grid
                    alignItems="center"
                    justify="center"
                    xs={8}
                    item
                    style={{flexGrow: 1}}
                >
                    <div className={classes.leftSection}>
                    {
                        selectListGroup?.length > 0 &&
                        warehouses?.length > 0 &&
                        partners?.length > 0 &&
                        airports?.length > 0 &&
                        selectListGroup.map((selectList, i) => (
                            <Grid xs={3} item style={{marginLeft: 20}}>
                                {
                                    selectList.id === 0 ?
                                    <Autocomplete
                                        multiple
                                        options={warehouses||[]}
                                        getOptionLabel={(option) => option.name}
                                        filterSelectedOptions
                                        limitTags={1}
                                        onChange={(event, value) => {
                                            setSelectedWarehouses(value);
                                            let warehouseIds = _.map(value, 'id')
                                            warehouseIds = warehouseIds?.length > 0 ? warehouseIds: null
                                            handleSearchKeys(warehouseIds, i)
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                label={selectList.label}
                                            />
                                        )}
                                        fullWidth
                                        value={selectedWarehouses}
                                    />
                                    :
                                    <FormControl
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                    >
                                        <InputLabel>{selectList.label}</InputLabel>
                                        <Select
                                            value={searchKeys[i]}
                                            onChange={(event)=>{handleSearchKeys(event.target.value, i)}}
                                        >
                                            <MenuItem value={null}>{t('select_none')}</MenuItem>
                                        {
                                            selectList.id === 2 &&
                                            partners.map((select) => (
                                                <MenuItem value={select.id}>{select.name}</MenuItem>
                                            ))
                                        }
                                        {
                                            (selectList.id === 3 || selectList.id === 4) &&
                                            airports.map((select) => (
                                                <MenuItem value={select.airport_code}>{select.airport_code}</MenuItem>
                                            ))
                                        }
                                        {
                                            (selectList.id === 1 || selectList.id === 5) &&
                                            selectList.list.map((select) => (
                                                <MenuItem value={select.id}>{select.text}</MenuItem>
                                            ))
                                        }
                                        </Select>
                                    </FormControl>
                                }
                            </Grid>
                        ))
                    }
                    {
                        props.inputList &&
                        props.inputList.map((input, i) => (
                        <Grid xs={3} item style={{marginLeft: 20}}>
                            <FormControl variant="outlined" fullWidth size="small">
                                <InputLabel
                                    shrink={true}
                                >
                                    {input.label}
                                </InputLabel>
                                <OutlinedInput
                                    value={searchKeys[input.index]}
                                    onChange={(event)=>{handleSearchKeys(event.target.value, input.index)}}
                                />
                            </FormControl>
                        </Grid>))
                    }
                    </div>    
                </Grid>
                <Grid item xs={1} alignItems="center" justify="center">
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={()=>props.onSearch(searchKeys, true)}
                    >
                        {t('common:search')}
                    </Button>
                </Grid>
                <Grid
                    alignItems="center"
                    justify="center"
                    xs={3}
                    item
                    style={{flexGrow: 1}}
                >
                    <div className={classes.rightSection}>
                        <div>{t('actions_to_selected')}</div>
                        <div style={{marginTop: 10}}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={()=>handleActive(true)}
                                disabled={!isSelected}
                            >
                                {t('activate')}
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                style={{marginLeft: 20}}
                                onClick={()=>handleActive(false)}
                                disabled={!isSelected}
                            >
                                {t('deactivate')}
                            </Button>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </Box>
    );
}
export default SearchActionsSection;